import React from 'react';
import { TfiBlackboard } from "react-icons/tfi";
import { CiLocationOn } from "react-icons/ci"; 
import { IoIosPhonePortrait } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";

const EventBookingCard = ({ event, onBookClick }) => {
  if (!event) return null;

  const { title, price, venue, city } = event;

  return (
    <div className="event-booking-container">
      <div className="event-booking-card">
        <div className="price-section">
          <span className="price-label">Price (KES)</span>
          <span className="price">KES {price?.toLocaleString() || "--"}</span>
        </div>

        <button className="book-button" onClick={onBookClick}>
          Book Event
        </button>

        <div className="event-booking-whatsapp-button">
          <button
            className="border-0"
            onClick={() => {
              const businessName = "Qentrain Solutions Ltd";
              const eventTitle = event?.title || 'N/A';
              const eventPrice = event?.price || 'N/A';
              const eventUrl = `https://qentrainsolutions.onrender.com/event/${event?._id}`;

              const message = encodeURIComponent(
                `Hello ${businessName},\n\nI'm interested in booking the event "${eventTitle}".\n\nPrice: KES ${eventPrice.toLocaleString()}\nEvent Link: ${eventUrl}\n\nPlease provide more details on how to proceed.\n\nThank you.`
              );

              const phoneNumber = "254720350903";
              const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

              window.open(whatsappUrl, '_blank');
            }}
          >
            <FaWhatsapp className="whatsapp-icon" /> Enquire on WhatsApp
          </button>
        </div>


        <div className="info-section">
          <div className="info-item">
            <TfiBlackboard className="info-icon" />
            <div>
              <span className="info-title">Course</span>
              <h4>{title || "Event Title"}</h4>
            </div>
          </div>

          <div className="info-item">
            <CiLocationOn className="info-icon" />
            <div>
              <span className="info-title">Location</span>
              <ul>
                <li>{venue || "Venue TBD"}</li>
                <li>{city || "City TBD"}</li>
              </ul>
            </div>
          </div>

          <div className="info-item">
            <IoIosPhonePortrait className="info-icon" />
            <div>
              <span className="info-title">Contact</span>
              <ul>
                <li>qentrainsolutions@gmail.com</li>
                <li>+254-720350903</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventBookingCard;

